import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import FormContainer from './FormContainer';
import { useNavigate } from 'react-router-dom';
import useApi from '../hooks/ApiHook';
import { useEffect, useState } from 'react';
import If from './If';

const industriesFrontUrl = process.env.REACT_APP_INDUSTRIES_FRONT_URL || 'http://localhost:3001'
const suppliersFrontUrl = process.env.REACT_APP_SUPPLIERS_FRONT_URL || 'http://localhost:3002'

const LoginForm = () => {
  const [ username, setUsername ] = useState('');
  const [ password, setPassword ] = useState('');
  const [ loading, setLoading ] = useState(false);
  const [ isValidUser, setValidUser ] = useState(false);
  const navigate = useNavigate();
  const api = useApi();

  useEffect(() => {
    if (isValidUser) {
      setTimeout(() => {
        document.getElementById('password').focus();
      }, 500);
    }
  }, [isValidUser])

  const verifyUser = async () => {
    setLoading(true);
    try {
      const { data } = await api.post('login/verify', { username });
      if (data.firstLogin) {
        newPassword();
      } else {
        setValidUser(true);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }

  const newPassword = async () => {
		try {
			setLoading(true);
			const result = await api.post('change-password/request', { username });
			navigate(`reset/verify?email=${result.data.email}&username=${username}`);
		} catch (e) {
			console.log(e);
		} finally {
			setLoading(false);
		}
	}

  const login = async () => {
    setLoading(true);
    try {
      const { data } = await api.post('login', { username, password });
      window.location.href = `${data.redirect === 'INDUSTRY' ? industriesFrontUrl : suppliersFrontUrl}/?authorization=${data.authorization}`;
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  }

  const submit = (e) => {
    e.preventDefault();
    if (!isValidUser) {
      verifyUser();
    } else {
      login();
    }
  }

  return (
    <FormContainer>
      <div className='text-3xl font-semibold text-black-alpha-90 mb-3'>
        Entre na sua conta
      </div>
      <form onSubmit={submit}>
        <div class="field">
          <label>Nome de usuário</label>
          <InputText 
            className='w-full' 
            placeholder='usuario@exemplo' 
            required
            value={username}
            onChange={e => setUsername(e.target.value)}/>
        </div>
        <If condition={isValidUser}>
          <div class="field">
            <label>Senha</label>
            <Password 
              inputId='password' 
              className='w-full' 
              inputClassName='w-full' 
              feedback={false} 
              required
              value={password}
              onChange={e => setPassword(e.target.value)}/>
          </div>
        </If>
        <div class="field">
          <Button className='w-full' label='Entrar' loading={loading}></Button>
        </div>
        <div class="field">
          <Button 
            className='w-full' 
            label='Esqueci minha senha' 
            severity="secondary"
            type='button'
            onClick={() => navigate('reset')}/>
        </div>
      </form>
    </FormContainer>
  );
}

export default LoginForm;